import { Text } from "@chakra-ui/react";
import { Modal } from "newui/components/ui/Modal";

export interface BlockedRemovalModalProps {
	isOpen: boolean;
	companyName: string;
	onClose: () => void;
}

// AC3/VT-013: attempting to remove the last recipient for a bidder org on a
// coverage-guaranteed type is blocked. newui Modal only — NEVER window.confirm.
export const BlockedRemovalModal = ({
	isOpen,
	companyName,
	onClose,
}: BlockedRemovalModalProps) => {
	return (
		<Modal
			isOpen={isOpen}
			title="Can't remove this recipient"
			iconType="error"
			primaryButton={{ text: "Okay", onClick: onClose }}
			onClose={onClose}
		>
			<Text data-testid="blocked-removal-modal">
				{companyName} would be left with no eligible recipient for a
				coverage-guaranteed notification type. Assign another recipient before
				removing this one.
			</Text>
		</Modal>
	);
};
